import React, { useEffect } from 'react';
import { ParticipantsLiveFormTabs } from '../../attendees-live-form.viewmodel';
import { AttendeeStatusTab } from './attendees-live-form-tab-header';
import { JOINED_TEXT, REGISTRANTS_TEXT } from '../../attendees-live-form.texts';
import { observer } from 'mobx-react';

interface IProps {
    joinedTotal: number;
    registrantsTotal: number;
    activeTab: string;
    isMeetingsWithCounters: boolean;
    setActiveTab: (tab: ParticipantsLiveFormTabs) => void;
}

const AttendeeStatusTabs = observer((props: IProps) => {
    const { joinedTotal = 0, registrantsTotal = 0, activeTab, isMeetingsWithCounters, setActiveTab } = props;
    useEffect(() => {
        if (joinedTotal <= 0 && registrantsTotal > 0) {
            setActiveTab(ParticipantsLiveFormTabs.REGISTRANTS);
        } else {
            setActiveTab(ParticipantsLiveFormTabs.JOINED);
        }
    }, []);

    return (
        <div className='attendees-live-form__status'>
            {(joinedTotal > 0 || isMeetingsWithCounters) && <AttendeeStatusTab
                total={joinedTotal}
                isActive={activeTab === ParticipantsLiveFormTabs.JOINED}
                selectTab={() => setActiveTab(ParticipantsLiveFormTabs.JOINED)}
                text={JOINED_TEXT}
            />}
            {registrantsTotal > 0 && <AttendeeStatusTab
                total={registrantsTotal}
                isActive={activeTab === ParticipantsLiveFormTabs.REGISTRANTS}
                selectTab={() => setActiveTab(ParticipantsLiveFormTabs.REGISTRANTS)}
                text={REGISTRANTS_TEXT}
            />}
        </div>
    );
});

export { AttendeeStatusTabs };